<template>
    <div>
         <commBanner :obj="obj"></commBanner>
         <titleHead :headTitle="headTitle"></titleHead>
         <div class="w80 mb-30">
             <el-container>
                <el-aside width="330px">
                    <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
                    <headSide v-else  @release="gorelease()"></headSide>
					 <!--详情-->
                     <div >
                        <div class="fsc mt-30">
                            <span class="lines"></span>
                            <span class="fawer_text">提问详情</span>
                            <span class="fawer_net" @click="Backer">返回</span>
                        </div>
                        <div class="question_details">
                        <div class="question_top">
                            <p class="text">{{problemObj.questionTitle}}</p>
                        </div>
                        <div class="question_middle" v-html="problemObj.questionContent"></div>
                        <div class="question_bottom">
                            <p>
                                <span>回答专家：</span><span>{{problemObj.expertname}}</span>
                            </p>
                            <p class="ml-30" v-if="problemObj.createDate">
                                <span>提问时间：</span><span>{{problemObj.createDate.substring(0,10)}}</span>
                            </p>
                            <p class="ml-30">
                            <span>回答情况：</span>
                                <span v-if="problemObj.status ==1" style="color:red" >未回答</span>
                                <span v-if="problemObj.status ==2" style="color:green" >已回复</span>
                            </p>

                        </div>
                        <div class="quest_muer">
                          <p><span>回答内容：</span> <span class="quest_muer_batre">{{problemObj.answer_content}}</span></p>
                        </div>
                        </div>
                        <div class="fsc mt-30">
                            <span class="lines"></span>
                            <span class="fawer_text">追问内容</span>
                        </div>
                        <div class="view_question" v-for="(info,index) in coment" :key="index">
                            <div v-if="1==info.type" >
                                <p>追问时间：{{info.date}}</p>
                                <div class="view_question_text">追问内容: {{info.content}}</div>
                            </div>
                            <div v-if="2==info.type" >
                                <p>回答时间：{{info.date}}</p>
                                <div class="view_question_text" style="color:red">回答内容: {{info.content}}</div>
                            </div>
                        </div>
                        <div class="tel mt-30">
                            <button class="view_question_but" v-if="put == true"  @click="onQuestion()">我要追问</button>
                            <div  v-else class="view_foot">
                                <el-input type="textarea" v-model="examineMinutely"></el-input>
                                <button  @click.prevent="onExamine()">提交追问</button>
                            </div>
                        </div>
                      </div>

                      <div style="margin-top:25%;">
                         <notList :notCode="notCode"></notList>
                      </div>

                </el-main>
            </el-container>
         </div>
    </div>
</template>
<script>
import {getProblem,delProblem,viewProblem,minutely} from "@/api/coment";
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
      sidebar,headSide,companySide,commBanner,titleHead,contTitle,Pagination,notList
  },
  data(){
      return{
        contTitle:'我的提问',
        headTitle:'我的问题',
        obj:{
            title:'我的问题',
            isShow:true,
            contCount:'',
            roleType:'',
            personalType:9
        },
        examineMinutely:'', //追问内容
        list:[],
        listQuery:{
            curPage:1,
            limit:5
        },
        total:0,//总条数
        problemObj:{},
        coment:[],
        notCode:false,
        questionId:'',
        type:false,
        isButton:false
      }
  },
  created(){
      let type = this.$store.state.user.userInfo.type;
      let id = this.$route.query.id;
      if(id){
          this.getviewProblem(id)
      }
      this.obj.roleType = type;
      if(type == 3){
         this.type = true;
         this.contTitle ="企业提问"
         this.headTitle = '企业问题';
         this.obj.title = '企业问题';
      }
  },
  methods:{
      gorelease(){
        this.$router.push('/demand')
      },
      //返回
	  Backer(){
	    this.$router.push('/problem')
	  },
	   //查看问题详情
      onView(data){
         this.showList  = false;
         this.put = true;
         this.getviewProblem(data);
      },
      //查询问题详情
      getviewProblem(id){
       let params = {id:id}
       viewProblem(params).then((res)=>{
         if(res.code == 0){
            this.problemObj = res.data;
            this.coment = res.data.data;
            this.questionId = res.data.id;
         }
         }).catch((err)=>{})
      },
      //查询问题详情
      getviewProblembyid(id){
       let params = {id:id}
       viewProblem(params).then((res)=>{
            if(res.code == 0){
                this.problemObj = res.data;
                this.coment = res.data.data;
                this.questionId=res.data.id;
            }
         }).catch((err)=>{})
      },
      //追问
      onQuestion(){
          this.put = false;
      },
      //提交追问
      onExamine(){
         let postData ={
              examineMinutely:this.examineMinutely,
              questionId:this.questionId
          };
          minutely(postData).then((res)=>{
             if(res.code ==0){
                 this.put = true;
                 this.$message({
                    message:'提交成功！',
                    type: 'success'})
                 this.getviewProblembyid(this.questionId);

             }
          }).catch((err)=>{})
      },
      //列表
      getList(){
          getProblem(this.listQuery).then((res)=>{
             if(res.code ==0){
               this.list = res.data.list;
               this.total = res.data.totalCount;
               this.obj.contCount = res.data.totalCount;
             }
            if(this.list.length ==0){
              this.notCode = true;
            }else{
              this.notCode = false;
            }
          }).catch(err=>{});
      },
      //分页
      pageChange(item){
         this.listQuery['curPage'] = item.page;
         this.listQuery['limit'] = item.limit;
         this.getList();
      },
      //删除问题
     onDelete(data){
        let params = {id:data.id}
        this.$confirm('确定要删除吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
         delProblem(params).then((res)=>{
          if(res.code ==0){
            this.$message({
            message:'删除成功！',
            type: 'success',
            duration:1000,
            onClose:()=>{
                this.getList();
            }
            });
          }
         }).catch((err)=>{})
        }).catch(()=>{
           this.$message({
           type: 'info',
           message: '已取消删除'
          });
        })

     }
  },
}
</script>
<style scoped>
.ml-15{
    margin-left: 15px;
}
.ml-30{
    margin-left: 30px;
}
.mt-30{
    margin-top: 30px;
}
.fawer_net{
	font-size: 12px;
	margin-left: 15px;
	margin-top: 5px;
}
.fawer_net:hover{
   cursor: pointer;
}
.cont_text{
  margin-left: 12px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    height: 113px;
    width: 100%;
    border: 1px solid #DEDEDE;
	transition: all 0.5s;
}
.content:hover{
   box-shadow: 0 0 20px #ddd;
}
.content_left{
    margin-left: 15px;
}
.content_left span.perice{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.content_left p{
    margin-top: 8px;
}
.content_left p span{
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FF7402;
}
.content_left p span.sign{
    font-size: 14px;
}
.content_middle{
   flex: 1;
   margin-left: 30px;
   text-align: left;
}
.content_middle p:nth-child(1){
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2;
}
.content_middle p.cont{
    margin-top: 15px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}
.content_right{
    margin-right: 15px;
    text-align: right;
}
.content_right p.time span{
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}
.content_right p.cont{
    margin-top: 15px;
    font-size: 13px;
}
.content_right p.cont:hover{
    cursor: pointer;
}
.content_right p span:nth-child(1){
    color: #9A9A9A;
}
.content_right p span{
    color: #343434;
}
.question_details{
    width: 100%;
    border: 1px solid #DEDEDE;
    margin-top: 20px;
    text-align: left;
}
.question_top{
    margin-top: 15px;
    margin-left: 15px;
}
.question_top p{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.question_top p.text{
    margin-top: 8px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.question_middle{
    margin-top:20px;
    margin-left: 15px;
}
.question_middle p:nth-child(1){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.question_middle img{
    width: 206px;
    height: 143px;
}
.question_bottom{
    margin: 15px 15px ;
    display: flex;
    justify-content: flex-start;
    align-content: center;
}
.question_bottom p span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
/**查看问题 */
.view_question{
    margin-top: 15px;
    width: 100%;
    /* height: 229px; */
    border: 1px solid #DEDEDE;
    text-align: left;
    padding: 0px 18px;
}
.view_question p{
    margin-top: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.view_question_text{
    margin: 15px 0px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #666666;
}
.view_question_but{
    width: 114px;
    height: 35px;
    background: #68BE32;
    border-radius: 3px;
    color: white;
    margin-bottom: 20px;
}

.view_foot{
    height: 300px;
    margin-top: 10px;
    text-align: left;
}
.view_foot>>>.el-textarea__inner{
  width: 100%;
  height: 200px;
}
.view_foot button{
    width: 114px;
    height: 35px;
    background: #68BE32;
    border-radius: 3px;
    color: white;
    margin-top: 20px;
}
.view_foot>>>.el-textarea__inner:focus{
    border-color:#DEDEDE;
}

.quest_muer{
    margin: 15px 15px ;
}
.quest_muer p span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.quest_muer p span.quest_muer_batre{
  white-space: normal;
  line-height:24px
}



.el-pagination{
   margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/problemDetail.vue